













import Vue from "vue";
export default Vue.extend({
  props: { elementId: String },
  methods: {
    openFullscreen() {
      const elem = document.getElementById(this.elementId) as any;
      if (elem!.requestFullscreen) {
        elem!.requestFullscreen();
      } else if (elem!.mozRequestFullScreen) {
        /* Firefox */
        elem!.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem!.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem!.msRequestFullscreen();
      }
    }
  }
});
